angular.module("componentes").directive("resetPasswordForm", [
	"$timeout",
	function ($timeout) {
		"use strict";
		return {
			scope: {},
			controller: "ResetPasswordFormCtrl",
			controllerAs: "ctrl",
			templateUrl: "views/login/components/resetPasswordForm_template.html"
		};
	}
]);
